
import { supabase } from './supabase';

type UpdatedSession = {
  access_token: string;
  refresh_token: string;
  expires_at?: number;
  expires_in?: number;
  token_type?: string;
};

export async function updatePassword(password: string): Promise<void> {
  const { data, error } = await supabase.auth.getSession();

  console.log('[Password Debug] Session:', {
    hasSession: Boolean(data.session),
    hasError: Boolean(error),
    hasAccessToken: Boolean(data.session?.access_token),
    hasRefreshToken: Boolean(data.session?.refresh_token),
  });

  if (error || !data.session) {
    throw new Error('Your session expired. Sign in again.');
  }

  console.log('[Password Debug] Validation:', {
    passwordLength: password.length,
    passwordType: typeof password,
    meetsMinimumLength: password.length >= 12,
    accessTokenLength: data.session.access_token.length,
    refreshTokenLength: data.session.refresh_token.length,
  });

  const response = await fetch('/api/complete-password-change', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      accessToken: data.session.access_token,
      refreshToken: data.session.refresh_token,
      password,
    }),
  });

  const result = await response.json().catch(() => null);

  console.log('[Password Debug] API Response:', {
    status: response.status,
    success: result?.success === true,
    error: result?.error ?? null,
  });

  if (!response.ok || result?.success !== true) {
    throw new Error(
      typeof result?.error === 'string'
        ? result.error
        : 'Unable to update your password. Please try again.'
    );
  }

  if (result.session) {
    const updatedSession = result.session as UpdatedSession;

    const { error: sessionError } =
      await supabase.auth.setSession(updatedSession);

    if (sessionError) {
      throw new Error(
        'Your password changed, but your session could not be refreshed. Sign in again.'
      );
    }
  }

  console.log('[Password Debug] Password change completed');
}
